import AirDrop from './index';

export default { path: '/home/airdrop', component: AirDrop };
